import React from 'react';
import PropTypes from 'prop-types';
import {Field} from 'redux-form';

import Form from '@appComponents/ReduxFormControls';

export const ContentVariantsFilter = ({
    eventContentVariants = [],
    loading = false,
    filters,
    restoreFilterValues,
}) => (
    <Field
        className='--customWidth --contentVariant'
        component={Form.ReduxSelect}
        disabled={loading}
        loading={loading}
        multiple
        name='eventContentVariants'
        options={eventContentVariants}
        placeholder='Content variant'
        search
        setValue={restoreFilterValues(filters, 'eventContentVariants')}
    />
);

ContentVariantsFilter.propTypes = {
    eventContentVariants: PropTypes.array,
    loading: PropTypes.bool,
    filters: PropTypes.object.isRequired,
    restoreFilterValues: PropTypes.func.isRequired,
};
